import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { appRoutesByName } from '../../containers/app/Routes';

interface OwnProps {
  routeName: string;
  component: React.ComponentType;
}

const PreviousStepCompleteRoute: React.FC<OwnProps> = ({ component: Component, routeName }) => {
  const previousStepComplete = useAppSelector((state) => {
    const appRoute = appRoutesByName[routeName];
    return appRoute.isPreviousStepComplete(state);
  });

  return previousStepComplete ? <Component /> : <Navigate to="/" />;
};

export default PreviousStepCompleteRoute;